export default new class scrollTo {
    constructor() {
        this.init();
    }

    init() {
        $(".js-scroll-to").on("click", function(){
            let element_to_scroll = $(this).data('box'),
                container = $("html,body"),
                scrollTo = $(`section[data-scroll='${element_to_scroll}']`);

            if(scrollTo && scrollTo.length)
                container.animate({scrollTop: scrollTo.offset().top},300);

            return false;
        });


        // js-scroll-to
        // if (this.scrollTop !== 0) {
        //     document.querySelector("main").scrollTo(0, this.scrollTop);
        // }

    }
}();
